<template>
  <div
    class="relative"
    :class="{
      'pb-48': isNotStartPage,
    }"
  >
    <div>
      <div class="w-full overflow-hidden sm:pt-32">
        <component
          :is="components[component.layout]"
          v-for="(component, idx) in document.components"
          :key="component.layout + idx"
          v-bind="{ component }"
          :has-side-bar="hasSideBar"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BlockComponents from '../../constants/block-components';
import Page from '~/models/page';

export default defineComponent({
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    document(): Page {
      return new Page({ contentData: this.page });
    },
    components(): typeof BlockComponents {
      return BlockComponents;
    },
    links(): any[] {
      return this.page.sidebar_links ? this.page.sidebar_links : [];
    },
    isNotStartPage(): boolean {
      return false;
      /**
       * @todo - store?
       */
      /*return !config.startPageUrls.includes(
        `${process.env.FRONTEND_URL}${this.$route.fullPath}`
      );*/
    },
    hasSideBar(): boolean {
      return this.links.length > 0;
    },
  },
});
</script>
